/**
 * Append `from=guided` so wizards return to the dashboard journey sheet.
 * @param {string} path
 * @returns {string}
 */
export function withGuidedReturn(path) {
  if (!path) return path;
  try {
    const url = new URL(path, 'https://evplanner.local');
    url.searchParams.set('from', 'guided');
    return `${url.pathname}${url.search}`;
  } catch {
    const join = path.includes('?') ? '&' : '?';
    return `${path}${join}from=guided`;
  }
}

export const GUIDED_FLOW_RETURN_PATH = '/app/dashboard?openGuidedFlow=1';

export default withGuidedReturn;
